<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {
    // Index
  },
  created() {},
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      if (window.innerWidth <= 750) {
        document.body.style.zoom = window.innerWidth / 750;
      } else if (window.innerWidth > 750 && window.innerWidth <= 1000) {
        document.body.style.zoom = 0.85;
      } else {
        document.body.style.zoom = window.innerWidth / 1920;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
@media screen and (max-width: 1000px) {
  #app {
    height: 100%;
    max-width: 750px;
    margin: 0 auto;
    background-color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue